import { render } from "./PromemoriaPubblico.vue?vue&type=template&id=6fed642e&scoped=true"
import script from "./PromemoriaPubblico.vue?vue&type=script&lang=js"
export * from "./PromemoriaPubblico.vue?vue&type=script&lang=js"

import "./PromemoriaPubblico.vue?vue&type=style&index=0&id=6fed642e&scoped=true&lang=css"
import "../../assets/css/staff-reminder-controls.css?vue&type=style&index=1&id=6fed642e&scoped=true&lang=css&external"
import "../../assets/css/staff-reminders-table.css?vue&type=style&index=2&id=6fed642e&scoped=true&lang=css&external"
import "../../assets/css/staff-editor-dialog.css?vue&type=style&index=3&id=6fed642e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fed642e"]])

export default __exports__